import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Alert, Avatar, Box, Button, CircularProgress, Grid, Link, TextField, Typography } from "@mui/material";
import { useState } from "react";
import CommonNonAuthenticatedPageLayout from "../components/CommonNonAuthenticatedPageLayout";
import Copyright from "../components/CopyRight";
import { AuthenticationInstance } from "../utils/authenticationClass";

export const Login = () => {
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });
  const [error, setError] = useState(AuthenticationInstance.getError() ?? "");
  const [loading, setLoading] = useState(false);

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setCredentials((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    setLoading(true);
    await AuthenticationInstance.handleSignIn(credentials)
      .then(() => setError(""))
      .catch((error: any) => setError(error.message || "An unexpected error occurred"))
      .finally(() => setLoading(false));
  };

  return (
    <CommonNonAuthenticatedPageLayout>
      <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        Sign in
      </Typography>
      <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1, width: "100%" }}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="username"
          label="Username or Email"
          name="username"
          autoComplete="username"
          autoFocus
          onChange={handleChange}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type="password"
          id="password"
          autoComplete="current-password"
          onChange={handleChange}
        />
        {error && (
          <Alert severity="error" sx={{ width: 1, my: 1 }}>
            {error}
          </Alert>
        )}
        <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
          {loading ? <CircularProgress /> : "Sign In"}
        </Button>
        <Grid container>
          <Grid item xs>
            <Link href="/forgot-password" variant="body2">
              Forgot password?
            </Link>
          </Grid>
        </Grid>
        <Copyright sx={{ mt: 5 }} />
      </Box>
    </CommonNonAuthenticatedPageLayout>
  );
};

export default Login;
